import axios from 'axios'
import {setCookie} from './setCookie'

class DriveScout {

    constructor(){
        const AUTH_TOKEN_KEY = 'dc-auth-token';
        const EXPIRATION_KEY = 'dc-token-expiration-date';

        this.AUTH_TOKEN_KEY = AUTH_TOKEN_KEY;
        this.EXPIRATION_KEY = EXPIRATION_KEY;

        let baseUrl =  null;
        if (process.env.MIX_DRIVESCOUT_BASE_URL) {
            baseUrl = process.env.MIX_DRIVESCOUT_BASE_URL
        }

        if (baseUrl === null){
            throw new Error("Base URL not set.");
        }

        this.http = axios.create({
            baseURL: baseUrl,
            timeout: 1000,
            validateStatus: (status) => {
                return status >= 200 && status < 300;
            }
        });

        this.goToDriveScout = this.goToDriveScout.bind(this);
        this.setUser = this.setUser.bind(this);
    }

    login(username, password){
        return this.http.post('/auth', {'username' : username, 'password' : password}).then(response => {
            return response;
        }).catch(Error => {
            throw Error;
        })
    }

    forgotPassword(username){
        return this.http.post('/api/v1/remindPassword', {'username' : username}).then(response => {
            return response.data;
        });
    }

    goToDriveScout(response){
        setCookie(this.AUTH_TOKEN_KEY, window.localStorage.getItem(this.AUTH_TOKEN_KEY), 30);
        window.location.assign(response.data.redirect_to);
    }

    setUser(response){
        window.localStorage.setItem(this.AUTH_TOKEN_KEY, response.data.access_token);
        window.localStorage.setItem(this.EXPIRATION_KEY, response.data.expires_in);
    }
}

export {DriveScout}
